export const createReactModuleCode = (name: string, value: string): string => {
	return `const ${name} = ${value};

// Polyfill for useSyncExternalStore (React 18+)
const useSyncExternalStorePolyfill = ${name}.useSyncExternalStore || function(subscribe, getSnapshot, getServerSnapshot) {
	const [state, setState] = ${name}.useState(getSnapshot);

	${name}.useEffect(() => {
		const handleStoreChange = () => {
			setState(getSnapshot());
		};
		const unsubscribe = subscribe(handleStoreChange);
		handleStoreChange(); // Check for changes since last render
		return unsubscribe;
	}, [subscribe, getSnapshot]);

	return state;
};

export default ${name};
export const {
	Component,
	PureComponent,
	Fragment,
	StrictMode,
	Suspense,
	Profiler,
	createElement,
	cloneElement,
	createFactory,
	createRef,
	forwardRef,
	isValidElement,
	createContext,
	memo,
	lazy,
	Children,
	useCallback,
	useContext,
	useDebugValue,
	useEffect,
	useImperativeHandle,
	useLayoutEffect,
	useMemo,
	useReducer,
	useRef,
	useState,
	act,
	unstable_act,
	version
} = ${name};

export const useSyncExternalStore = useSyncExternalStorePolyfill;`
}
